<template>
  <div style="backgroundColor:#273C51; width:100%;">
<v-app style="backgroundColor:#273C51; max-width: 1300px">


  <v-snackbar
    v-model="sb.snackbar"
    :color="sb.color"
    center top multi-line
    :timeout="7000"
  >
    {{ sb.text  }}
    <v-btn @click="sb.snackbar = !sb.snackbar" style="text-transform:none !important" color="#273C51"> <v-icon style="margin-right:5px" small>mdi-close</v-icon>Закрыть</v-btn>
  </v-snackbar>


 <app-header > </app-header>

  <v-content class="vk_background"   >
 <router-view></router-view>
  </v-content>











<transition :duration="{ enter: 800, leave: 1800 }" >
  <v-btn v-if="scroll>0"

    color="#4A76A8"

    dark
    fab
    fixed
    bottom
    right
  >
  <v-icon @click="$vuetify.goTo(0)" dark medium  >mdi-hand-pointing-up</v-icon>
</v-btn>
</transition>


<v-footer   dark  app>

 <a target="_blank " style="text-decoration:none;" href="https://t.me/vkparser"><v-btn flat small style="text-transform:none !important"> <v-icon left color="#273C51">mdi-email</v-icon><span style="color:gray">Oleg Volkov</span></v-btn></a>



 <div v-if="ini.title" class="text-xs-center">
   <v-bottom-sheet inset   scrollable     v-model="modals.selectServer">
     <template v-slot:activator>
       <v-btn
       flat small  style="text-transform:none !important"> <v-icon color="green" left>mdi-server</v-icon>
         Сервер: {{ini.title}}
       </v-btn>
     </template>

     <v-card >
  <v-toolbar class="white--text" flat height="42" color="#273C51">
      <v-toolbar-title>Выбрать сервер</v-toolbar-title> <v-spacer/>
      <v-icon @click="modals.selectServer = false" color="white">mdi-close</v-icon>
  </v-toolbar>
       <v-card-text>
     <v-list style="overflow:scroll;overflow-x:hidden;max-height:350px;color:#4A76A8">
       <v-list-tile  v-for="item in servers" :key="item.title" @click="sheet = false">
         <v-list-tile-title @click="selectServer(item)" v-if="item.title !== ini.title">
            <v-icon color="green" style="margin-right:5px">mdi-server</v-icon>
            {{ item.title }}
          </v-list-tile-title>
          <v-list-tile-title v-else>
             <v-icon color="gray" style="margin-right:10px">mdi-server</v-icon>
             <span style="color:gray">Текущий сервер: {{ item.title }}</span>
           </v-list-tile-title>
       </v-list-tile>
     </v-list>
   </v-card-text>

   </v-card>

   </v-bottom-sheet>
 </div>



 <v-btn v-else flat disabled style="text-transform:none">
 <v-icon left>mdi-alert</v-icon>
 <span >Сервер отсутствует</span>
 </v-btn>


</v-footer>






</v-app>
</div>
</template>

<script>
import axios from 'axios'
export default {

  data () {
    return {
  servers: [
    { title: 'Keep' },
    { title: 'Inbox' },
    { title: 'Hangouts' },
    { title: 'Keepa' },
  ],
  modals:{
    selectServer:false,
  },
 sb:{
   snackbar:false,
   color:'red',
   text:'',
 },


 startApp: this.$store.state.ui.startApp,
 status: '',

 startAuth: false,
 errAuthFirst: true,
 errAuth: false,

  ini: {
    title:"",
    server: "localhost",
    path: "vkback",
    loginSql: "root",
    paswordSql:"",
    serverSql: "localhost",
  },
   scroll: 0,
   allOk: false,

    }
  },

 methods: {
  selectServer(item){
     localStorage.server = JSON.stringify(item)
     this.$router.go()
   },

  startWork(){
         axios.post('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/parser/delete_unseved.php')
         .then(response =>{
         this.$store.dispatch('changeCounters')
         })
  }

 },

mounted(){
window.addEventListener('scroll',  ()=>{
this.scroll = window.scrollY
})
},

created (){
if(localStorage.server){
let server = JSON.parse(localStorage.server)
this.$store.state.localhost = server.server
this.ini = server

this.servers = JSON.parse(localStorage.servers)
// clear mysql logs
axios.post('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/start.php')
}

this.$store.dispatch('getBotFilters')
this.$store.dispatch('getProfilesGroups')
this.$store.dispatch('changeCounters')
},

    watch: {
      $route: {
          immediate: true,
          handler(to, from) {
              document.title = to.meta.title || ' ВкПлюс Парсер активности вконтакте';
              const link = document.querySelector("[rel='icon']")
              link.setAttribute('href',"./img/ico1.png")

              if(!localStorage.server){
                to.path === '/auths'? true : this.$router.push('/auths')
                this.sb.text = 'Для работы необходимо добавить или выбрать сервер, обратитесь в подержку если нет сервера'
                this.sb.snackbar = true
                //to.path === '/auth'? true : alert('Для работы необходимо добавить как минимум 1 сервер, обратитесь в подержку если нет сервера')
              }



          }
      },
},

}
</script>

<style>
:hover {
  text-decoration:none !important
}


.vk_background {

  margin:0 auto;
  background-color:  #273C51 !important;
  width:100%;

}
</style>
